import type { OrderException, OrderLineInput, OrderPhase, OrderStatus } from "@kitchen/schemas";

/** Persian labels shared by the staff and customer order screens. Polite wording only (DL-010). */

export const STATUS_LABEL: Record<OrderStatus, string> = {
  draft: "پیش‌نویس",
  submitted: "ثبت شد",
  returned: "برگشت برای اصلاح",
  approved: "تأیید شد",
  "in-production": "در دست پخت",
  ready: "آماده",
  assigned: "با راننده",
  "on-route": "در مسیر",
  delivered: "تحویل شد",
  "delivered-short": "تحویل با اختلاف",
  failed: "تحویل نشد",
  cancelled: "لغو شد",
};

export const STATUS_TONE: Partial<Record<OrderStatus, "blue" | "ok" | "warn" | "coral" | "dark">> = {
  submitted: "warn",
  returned: "coral",
  approved: "ok",
  "in-production": "blue",
  ready: "blue",
  delivered: "ok",
  cancelled: "dark",
};

export const EXCEPTION_LABEL: Record<OrderException, string> = {
  late: "دیرهنگام",
  "change-request": "درخواست تغییر",
  "unusual-quantity": "تعداد غیرعادی",
  "extra-line": "ردیف اضافه",
  unpriced: "بی‌قیمت",
};

export const PHASE_LABEL: Record<OrderPhase, string> = {
  open: "ثبت و ویرایش آزاد",
  late: "بعد از مهلت: ویرایش با علامت دیرهنگام",
  locked: "بعد از قفل پخت: درخواست تغییر",
};

/** Today's business date in Tehran, ISO. */
export function tehranToday(now = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Tehran" }).format(now);
}

export function addDays(iso: string, n: number): string {
  const [y, m, d] = iso.split("-").map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}

/** A food × tier key; one line per key in an order. */
export const lineKey = (l: { menuItemId: string; tierId: string | null }) =>
  `${l.menuItemId}|${l.tierId ?? "-"}`;

export const toLineInputs = (
  ls: readonly {
    menuItemId: string;
    tierId: string | null;
    orderedQuantity: number;
    note: string;
    extra: boolean;
  }[],
): OrderLineInput[] =>
  ls.map((l) => ({
    menuItemId: l.menuItemId,
    tierId: l.tierId,
    quantity: l.orderedQuantity,
    note: l.note,
    extra: l.extra,
  }));
